import React, { Fragment, useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { Desktop, Mobile } from "../../../../hocs/Responsive";
import { CsvDownload } from "../csvDownload/CsvDownload";
import { DrilldownRoutePage } from "../../drilldown.types";
import {
  MobileSort,
  TableSearch,
} from "../../../../components/table/components";
import {
  getReportsPeriod,
  getSelectedReportsProfile,
} from "../../../../store/reports/reports.selectors";

interface DrilldownTableHeaderProps {
  page: DrilldownRoutePage;
}

export const DrilldownTableHeader = ({ page }: DrilldownTableHeaderProps) => {
  const [filterValue, setFilterValue] = useState("");
  const reportsPeriod = useSelector(getReportsPeriod);
  const reportsProfile = useSelector(getSelectedReportsProfile);

  useEffect(() => {
    setFilterValue("");
  }, [reportsPeriod, reportsProfile, page]);

  return (
    <Fragment>
      <Desktop>
        <div className={"drilldowns__table__info"}>
          <CsvDownload page={page} />
        </div>
      </Desktop>

      <TableSearch
        value={filterValue}
        onSearchChange={(value: string) => setFilterValue(value)}
      />

      <Mobile>
        <MobileSort />
      </Mobile>
    </Fragment>
  );
};
